module.exports = __webpack_public_path__ + "app/principal/peppol-reception-2oA3OP-G.html";